import { type ReactNode } from 'react';

const TD = 'pl-xs pr-md py-sm';
const BAR = 'animate-pulse rounded-sm bg-white/[0.05]';

function Cell({ w }: { w: string }): ReactNode {
  return (
    <td className={TD}>
      <div className={`h-3 ${w} ${BAR}`} />
    </td>
  );
}

function SkeletonRow(): ReactNode {
  return (
    <tr className="h-[41px] border-b border-white/[0.03]">
      <Cell w="w-4" />
      <td className="py-sm">
        <div className={`h-6 w-6 rounded-full ${BAR}`} />
      </td>
      <Cell w="w-24" />
      <Cell w="w-8" />
      <Cell w="w-8" />
      <Cell w="w-8" />
      <Cell w="w-12" />
    </tr>
  );
}

export function LeaderboardSkeleton(): ReactNode {
  return (
    <tbody>
      {Array.from({ length: 10 }, (_, i) => (
        <SkeletonRow key={i} />
      ))}
    </tbody>
  );
}
